import {SVGProps} from "react";

export const CopySvg = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M3.84615 10H3.23077C2.90435 10 2.5913 9.87033 2.36048 9.63952C2.12967 9.4087 2 9.09565 2 8.76923V3.23077C2 2.90435 2.12967 2.5913 2.36048 2.36048C2.5913 2.12967 2.90435 2 3.23077 2H8.76923C9.09565 2 9.4087 2.12967 9.63952 2.36048C9.87033 2.5913 10 2.90435 10 3.23077V3.84615"
                stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M6 7.33333C6 6.59695 6.59695 6 7.33333 6H12.6667C13.403 6 14 6.59695 14 7.33333V12.6667C14 13.403 13.403 14 12.6667 14H7.33333C6.59695 14 6 13.403 6 12.6667V7.33333Z"
                stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}
